export default defineNuxtPlugin(async () => {
  // Charger la langue sauvegardée au démarrage
  if (process.client) {
    const savedLanguage = localStorage.getItem('preferred-language');
    const route = useRoute();
    const switchLocalePath = useSwitchLocalePath();
    const currentLocale = route.params.locale || 'fr-FR';
    
    if (savedLanguage && savedLanguage !== currentLocale) {
      // Rediriger vers la langue sauvegardée si différente
      await navigateTo(switchLocalePath(savedLanguage));
    }
  }
});
